/* eslint-disable no-undef */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { getInputIndex } from 'helpers/actionHelpers';
import Types from 'constants/types';
import LocaleContext from 'constants/localization';

import ResourceLinkEdit from 'field/edit/resource/ResourceLinkEdit';
import EditResourceDisplay from 'field/edit/resource/EditResourceDisplay';
import Header from 'field/common/Header';
import Required from 'field/common/Required';

// Added during SPEC-40, open modal to search objects for linking
const AcquisitionEdit = (props) => {
  const view = useSelector(state => state.object.view);
  const museum = useSelector(state => state.object.museum);
  const LS = useContext(LocaleContext);
  const field = props.field;

  const targetType = Types.SPECTRUM.TARGET_TYPE;

  const onRemove = e => {
    if (confirm(LS.prompt.removeAcquisition)) {
      const index = getInputIndex(e);
      field.removeResource(index, field.values[index]);
    }
  };

  // SPEC-286 constraint AcquisitionSearch with 2 parameters: museum + targetType
  const searchParameters ={
    constraint: `AcquisitionInformation->${museum}+${targetType}#${view}`,
    searchView: 'AcquisitionInformation',
    negativeSearch: 'no',
    searchOperation:	'new',
    searchAll: true,
    forceExecute: true
  };

  return (
    <div className="field">
      <Header field={field} />
      <ResourceLinkEdit searchParameters={searchParameters} {...props} />
      {
        field.values.map((acquisition, key) => (
          <div key={key}>
            <EditResourceDisplay value={acquisition} />
            <button 
              className="action-link" 
              type="button"
              index={key}
              onClick={onRemove}>
              {LS.actions.remove}
            </button>
          </div>
        ))
      }
      <Required minOccurs={field.props.minOccurs} valueCount={field.values.length} />
    </div>
  );
};

export default AcquisitionEdit;